import React from "react";
import { useProductData } from "@/zustand/productStore.js";
import { useCartData } from "@/zustand/cartStore.js";
import { useCalculateProductCardPrice } from "@/func/orderCalculations.js";
import TagIcon from "@/utils/images/tagIcon";
import { motion } from "framer-motion";
import DiscountTagBlock from "@/components/orderSummary/DiscountTagBlock";
import SubscriptionTagBlock from "@/components/orderSummary/SubscriptionTagBlock";

const ProductCardVariant = ({ product, index, type, variant, amount }) => {
  const productData = useProductData();
  const { warrantyState, discountCode, isSubscribe } = useCartData();
  const warrantyLabel = window.post_template.checkout_v4_products.tr_checkout_v4_products_warrantyLabel;
  const discountAppliedLabel = window.post_template?.checkout_v4_summary?.tr_checkout_v4_discountApplied;
  const colorsData = productData?.product_color_variants;
  const isBundleDesign = productData?.show_bundle_design;
  const variantObject = colorsData?.find((item) => {
    return item.value == variant.color;
  });

  // additional data extending selected product
  const extendedProduct = productData?.products?.find((obj) => obj.price == product?.price);
  const additionalText = extendedProduct?.tr_additional_texts;

  const fallbackImageIndex = productData?.products?.findIndex(
    (productObj) => Number(product?.price) === Number(productObj?.price)
  );

  const fallbackImageUrl =
    fallbackImageIndex !== -1 && fallbackImageIndex !== undefined
      ? productData?.products?.[fallbackImageIndex]?.image?.url
      : null;

  const image = variantObject?.variant_image || fallbackImageUrl;
  const bundleImage = extendedProduct?.order_summary_bundle_image;
  const bundleImageFallback = bundleImage || image;

  const productPriceBlock = (price) => {
    const formattedPrice = productData?.formatted_string?.replace(/(0\.00|0,00|0)/, price);

    return (
      <div className="productCard__priceBlock">
        <span className="productCard__priceBlock__oldPrice">{"199,99"}</span>
        <span className="productCard__priceBlock__price">{formattedPrice}</span>
      </div>
    );
  };

  const { price, promoPrice } = useCalculateProductCardPrice(product, amount);

  const DiscountAppliedBadge = (price, promoPrice) => {
    const additionalDiscount = (Number(price) - Number(promoPrice)).toFixed(2);

    const formattedDiscount = productData?.formatted_string?.replace(/(0\.00|0,00|0)/, additionalDiscount);

    return (
      <div className="productCard__titleBlock__tagText">
        <TagIcon />
        {discountCode} {`(-${formattedDiscount})`}
      </div>
    );
  };

  return (
    <div key={index} className="productCard">
      <div className="productCard__imageContainer">
        <motion.div
          key={isBundleDesign ? bundleImageFallback : image}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            delay: 1,
            default: { duration: 0.5 },
          }}
        >
          <img src={isBundleDesign ? bundleImageFallback : image} alt={general_settings.brand_name} />
        </motion.div>
        {!isBundleDesign && <span className="productCard__imageContainer__indicator">{variant.amount}</span>}
      </div>
      <div className="productCard__titleBlock">
        <div className="productCard__titleBlock__title">
          {isBundleDesign && (
            <span>
              {product?.amount}x{" – "}
            </span>
          )}
          {product.display_name} {type !== "fake" && warrantyState && <span>{warrantyLabel}</span>}
        </div>
        {isBundleDesign && <div className="productCard__titleBlock__subtitle">{product.tr_bundle_products}</div>}
        <p className="productCard__titleBlock__variant">
          <span>{variant.sizeLabel}</span> {variant.color && variant.size ? "/" : ""} <span>{variant.colorLabel}</span>
        </p>

        {productData?.subscription?.subscription_enable && isSubscribe && (
          <SubscriptionTagBlock productData={productData} product={product} />
        )}

        {window?.post_template?.checkout_v4_products?.checkout_v4_products_discountAppliedToggle && (
          <DiscountTagBlock discountAppliedLabel={discountAppliedLabel} />
        )}
        {additionalText && <div className="productCard__titleBlock__altText">{additionalText}</div>}

        {discountCode !== undefined && productData?.enable_discount_codes && DiscountAppliedBadge(price, promoPrice)}
      </div>
      {productPriceBlock(discountCode !== undefined && productData?.enable_discount_codes ? promoPrice : price)}
    </div>
  );
};
export default ProductCardVariant;
